<template>
  <v-app style="text-transform: uppercase;">
    <v-layout row justify-center>
      <v-flex class="pl-4 pr-4 mt-3 mb-4" xs12 sm11>
        <v-card>

          <v-toolbar color="grey" dark dense>
            <v-toolbar-title>Roles</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
                <!-- <v-toolbar-items> -->
                  <v-btn color="grey darken-2" dark class="mb-1" v-on="on">
                    Nuevo
                  </v-btn>
                <!-- </v-toolbar-items> -->
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field v-model.trim="editedItem.name" label="Nombre" :rules="notBlankRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-checkbox
                            v-if="editedIndex > -1"
                            v-model="activo"
                            label="Activo"
                            :value="activo"
                          ></v-checkbox>
                        </v-flex>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" dark @click.native="close">Cancelar</v-btn>
                          <v-btn v-if="editedIndex > -1" color="yellow darken-2" dark @click.native="editRole(editedItem)" :disabled="loading" :loading="loading">Guardar</v-btn>
                          <v-btn v-else color="yellow darken-2" dark @click.native="addRole(editedItem)" :disabled="loading" :loading="loading">Guardar</v-btn>
                        </v-card-actions>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-toolbar>

          <v-data-table
            dense
            :headers="headers"
            :items="listRoles"
            item-key="user"
            class="elevation-1"
            light
            actions
            :loading="loading"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            @page-count="pageCount = $event"
          >
            <template v-slot:item.action="{ item }">
              <v-icon color="orange"  class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon v-if="!item.deleted_at" color="red"  @click="deleteRole(item)">mdi-close</v-icon>
            </template>
          </v-data-table>
          <div class="text-center pt-2" v-if="listRoles.length > itemsPerPage">
            <v-pagination v-model="page" :length="pageCount" :total-visible='7'></v-pagination>
          </div>

        </v-card>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
const Swal = require('sweetalert2');
export default {

  data() {
    return {
      valid: true,
      dialog: false,
      loading:false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        { text: 'Rol', value: 'name', sortable: true },
        { text: 'Activo', value: 'activo', sortable: true },
        { text: 'Acciones', value: 'action' }
      ],
      editedIndex: -1,
      activo: true,
      editedItem: {
        name:'',
      },
      defaultItem: {
        name:'',
      },
      notBlankRules: [v => !!v || 'Este campo es requerido'],
    }
  },
  created() {
    this.$store.commit("SET_LAYOUT", "dashboard-layout");
  },
  computed: {
    ...mapGetters(["listRoles"]),
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Role' : 'Editar Role'
    }
  },
  mounted() {
    this.getRoles();
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  methods: {
    getRoles() {
      this.loading = true;
      this.$store.dispatch("GET_ROLES",  { url: "/roles" }).then((response) => {
        this.loading = false;
      })
      .catch(err => {
        console.log(err);
      });
    },
    editItem (item) {
      this.editedIndex = this.listRoles.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      if (this.editedItem.deleted_at) {
        this.activo = false
      }else {
        this.activo = true
      }
    },
    addRole(item){
      this.$store.dispatch("SAVE_ROLES",  { url: "/role", data: item } ).then(response => {
        this.close ();
        this.$swal({
          icon: 'success',
          title: 'Rol guardado correctamente',
          confirmButtonText: "Aceptar"
        })
        this.getRoles();
      })
      .catch(error => {
        console.log(error);
      });
    },
    editRole(item){
      if (this.$refs.form.validate()) {
        item.activo = this.activo
        this.$store.dispatch("EDIT_ROLE",  { url: "/role/" + item.id, data: item } ).then(response => {
          this.$swal({
            icon: 'success',
            title: 'Rol actualizado correctamente.',
            confirmButtonText: "Aceptar"
          })
          this.close();
          this.getRoles();
        })
          .catch(error => {
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: error.response.data.msg,
              confirmButtonText: "Aceptar"
            })
          });
      }
    },
    deleteRole (item) {
      this.$swal({
        title: '¿Desea eliminar el rol "' + item.name + '"?',
        text: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: "Aceptar"
      }).then((result) => {
        if (result.value) {
            this.$store.dispatch("DELETE_ROLE",  { url: "/role/" + item.id } ).then(res => {
              console.log(res);
            Swal.fire({
              icon: 'success',
              title: 'Rol eliminado correctamente.',
              confirmButtonText: "Aceptar"
            })
            this.getRoles();
          })
          .catch(err => {
            console.log(err);
            Swal.fire({
              icon: 'error',
              title: err.response.data.msg,
              confirmButtonText: "Aceptar"
            })
          });
        }
      })
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.$refs.form.reset()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.dialog = false
      }, 300)
    },
  }
}
</script>
